var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ml-2 flex-shrink-0",attrs:{"label":"","outlined":"","color":"primary"}},[_vm._v("Lock expired")])
}
var staticRenderFns = []

export { render, staticRenderFns }